<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
      </div>
      <div class="company-box">
        <div class="company">
          <el-link href="http://www.100ec.cn/enterprise/#/Inside?name=阿里巴巴" target="_blank">
           阿里巴巴
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=生意宝" target="_blank">
           生意宝
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=京东" target="_blank">
           京东
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=拼多多" target="_blank">
           拼多多
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=抖音" target="_blank">
           抖音
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=快手" target="_blank">
           快手
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=国美" target="_blank">
           国美
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=苏宁易购" target="_blank">
           苏宁易购
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=小米" target="_blank">
           小米
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=唯品会" target="_blank">
           唯品会
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=盒马" target="_blank">
           盒马
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=美团" target="_blank">
           美团
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=菜鸟" target="_blank">
            卓尔智联
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=顺丰" target="_blank">
            顺丰
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=京东物流" target="_blank">
           京东物流
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=百世物流" target="_blank">
           百世物流
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=日日顺" target="_blank">
           日日顺
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=纵腾集团" target="_blank">
           纵腾集团
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=递四方" target="_blank">
           递四方
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=燕文物流" target="_blank">
           燕文物流
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=欧冶云商" target="_blank">
           欧冶云商
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=钢银电商" target="_blank">
           钢银电商
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=怡亚通" target="_blank">
           怡亚通
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=积微物联" target="_blank">
           积微物联
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=钢宝股份" target="_blank">
           钢宝股份
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=天物大宗" target="_blank">
           天物大宗
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=煤链通" target="_blank">
           煤链通
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=铜道" target="_blank">
           铜道
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=卓尔智联" target="_blank">
           卓尔智联
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=中驰车福" target="_blank">
           中驰车福
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=中农网" target="_blank">
           中农网
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=冻品在线" target="_blank">
           冻品在线
          </el-link>
        </div>
      </div>
    </div>
    <div class="right-box">
      <div class="right-title">
        <span>热门人物</span>
      </div>
      <ul class="platform">
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=孙德良 供应链"
            target="_blank"
            >孙德良</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=徐雷 供应链"
            target="_blank"
            >徐雷</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=王卫 供应链"
            target="_blank"
            >王卫</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=万霖 供应链"
            target="_blank"
            >万霖</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=辛利军 供应链"
            target="_blank"
            >辛利军</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=陈琪 供应链"
            target="_blank"
            >陈琪</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=李丛杉 供应链"
            target="_blank"
            >李丛杉</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=刘晓春 供应链"
            target="_blank"
            >刘晓春</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=鲍跃忠 供应链"
            target="_blank"
            >鲍跃忠</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=李旻 供应链"
            target="_blank"
            >李旻</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=王澍敏 供应链"
            target="_blank"
            >王澍敏</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=赵晖 供应链"
            target="_blank"
            >赵晖</a
          >
        </li>
      </ul>
    </div>
    <Email />
    <div class="right-box">
      <div class="right-title">
        <span>战略合作</span>
      </div>
      <ul class="partner-list">
        <li style="background:#111">
          <el-link href="https://www.rawmex.cn/" target="_blank">
            <img style="padding-top:10px"
              src="/Public/home/images/gylt/logo-1.png"
            />
          </el-link>
        </li>
        <li>
          <el-link href="https://www.dazpin.com/" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-2.png"
            />
          </el-link>
        </li>
        <li>
          <el-link href="https://www2.sinoloans.cn/" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-3.png?v=1.0"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.ctbmall.com/" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-4.gif"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.mlt-mall.com/" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-5.png"
            />
          </el-link>
        </li>
        <li>
          <el-link>
            <img
              src="/Public/home/images/gylt/logo-6.png?v=1.0"
            />
          </el-link>
        </li>
        <li>
          <el-link>
            <img
              src="/Public/home/images/gylt/logo-7.png?v=1.0"
            />
          </el-link>
        </li>
        <li>
          <el-link href="https://jinbao.dazpin.com/" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-8.jpg"
            />
          </el-link>
        </li>
      </ul>
    </div>
    <div class="right-box">
      <div class="right-title">
        <span>主要银行</span>
      </div>
      <ul class="partner-list">
        <li >
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%B7%A5%E5%95%86%E9%93%B6%E8%A1%8C" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-gsyh.webp"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%86%9C%E4%B8%9A%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-nyyh.webp"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E4%B8%AD%E5%9B%BD%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-zgyh.webp"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%BB%BA%E8%AE%BE%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-jsyh.webp"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E4%BA%A4%E9%80%9A%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-jtyh.gif"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E4%B8%AD%E4%BF%A1%E9%93%B6%E8%A1%8C" target="_blank"> 
            <img
              src="/Public/home/images/gylt/logo-zxyh.webp"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E6%B5%A6%E5%8F%91%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-pfyh.webp"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%85%B4%E4%B8%9A%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-xyyh.webp"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E6%B0%91%E7%94%9F%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-msyh.webp"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E6%B5%99%E5%95%86%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-zsyh.webp"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%85%89%E5%A4%A7%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-gdyh.jpg"
            />
          </el-link>
        </li>
        <li>
          <el-link href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E4%B8%8A%E6%B5%B7%E9%93%B6%E8%A1%8C&cgy=zh" target="_blank">
            <img
              src="/Public/home/images/gylt/logo-shyh.webp"
            />
          </el-link>
        </li>
      </ul>
    </div>
    <div style="width: 365px">
      <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
        <img style="width: 100%" src="/Public/home/images/zyttk/zytgg/gyyt/xfpjr.jpg" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      activeName: "fourth",
    };
  },
  // created() {
  //   this.$store.commit("getCompanyTabs", this.params);
  // },
};
</script>
<style scoped>
.partner-list li {
    padding: 10px;
    flex: 0 0 20%;
}
.partner-list img {
    width: 106px;
    border-radius: 2px;
    opacity: 1;
    transition: all .3s ease;
}
.platform a{
  color: #111;
}
.platform a:hover{
  color: #fff;
}
</style>